/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generating_StatusInputs */

const en_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating Code... please wait.`)
};

const fr_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation du code... veuillez patienter.`)
};

const de_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code wird generiert... bitte warten.`)
};

const it_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione del codice... attendere prego.`)
};

const ru_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация кода... пожалуйста, подождите.`)
};

const es_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando código... por favor espere.`)
};

const zh_cn2_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成代码……请稍候。`)
};

const ja_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを生成しています...お待ちください。`)
};

const hi_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोड जनरेट हो रहा है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_offline_activation_generating_status = /** @type {(inputs: Offline_Activation_Generating_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando código... aguarde.`)
};

/**
* | output |
* | --- |
* | "Generating Code... please wait." |
*
* @param {Offline_Activation_Generating_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generating_status = /** @type {((inputs?: Offline_Activation_Generating_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generating_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_generating_status(inputs)
	if (locale === "de") return de_offline_activation_generating_status(inputs)
	if (locale === "it") return it_offline_activation_generating_status(inputs)
	if (locale === "ru") return ru_offline_activation_generating_status(inputs)
	if (locale === "es") return es_offline_activation_generating_status(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_generating_status(inputs)
	if (locale === "ja") return ja_offline_activation_generating_status(inputs)
	if (locale === "hi") return hi_offline_activation_generating_status(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_generating_status(inputs)
	return en_offline_activation_generating_status(inputs)
});